import React from 'react'
import ChangePasswordModal from './ChangePasswordModal'
import ContactInfoModal from './ContactInfoModal'
import PaymentInfoModal from './PaymentInfoModal'
import TxReceiptModal from './TxReceiptModal'

const UserMenuModals = ({
    modal,
    onClose,
}) => {
    return (
        <div>
            {modal === "contact-info" && <ContactInfoModal onClose={onClose} />}
            {modal === "change-pass" && <ChangePasswordModal onClose={onClose} />}
            {modal === "payment-info" && <PaymentInfoModal onClose={onClose} />}
            {modal === "tx-rec" && <TxReceiptModal onClose={onClose} />}
        </div>
    )
}

export default UserMenuModals